
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

class Target extends EventTarget {
  id = "";
  // constructor(parameters) {

  // }
}

@Component({})
export default class SvgImg extends Vue {
  name = "SvgImg";
  img = require("@/assets/videoPaly.svg");
  isView = true;
  playId = "";
  @Prop({ type: Boolean, default: true }) isShow!: boolean;
  @Prop({ type: String, default: "" }) videoId!: string;
  @Prop({ type: String, default: "" }) videoRef!: string;
  @Watch("isShow", { immediate: true })
  onChangeView(val: boolean) {
    this.isView = val;
  }
  videoList: HTMLVideoElement[] = [];
  mounted() {
    this.$nextTick(() => {
      const refs = this.$parent.$refs;
      this.getVideoList(refs);
    });
  }
  //   点击
  playVideo() {
    const video = this.$parent.$refs[this.videoRef] as
      | HTMLVideoElement[]
      | HTMLVideoElement;
    if (Array.isArray(video)) {
      const videoTarget = video.find(
        (item: HTMLVideoElement) => item.id === this.videoId
      );
      if (videoTarget) videoTarget.play();
    } else {
      video.play();
    }
  }
  // 添加视频事件监听
  addVideoEventListener(video: HTMLVideoElement, key: string) {
    // play：播放监听
    video.addEventListener("play", (e: Event) => {
      const target = e.target as Target;
      this.closeVideo(video.id);
      if (target) {
        this.playId = target.id;
        this.isView = this.videoRef !== key && target.id !== this.videoId;
      }
    });
    // pause：暂停监听
    video.addEventListener("pause", () => {
      if (this.videoRef === key) this.isView = true;
    });
  }
  //   处理视频元素
  getVideoList(video: any) {
    for (const key in video) {
      if (Array.isArray(video[key])) {
        video[key].forEach((item: any) => {
          if (item.nodeName === "VIDEO") {
            this.addVideoEventListener(item, key);
            this.videoList.push(item as HTMLVideoElement);
          }
        });
      } else if (video[key]) {
        if (video[key].nodeName === "VIDEO") {
          this.addVideoEventListener(video[key], key);
          this.videoList.push(video[key] as HTMLVideoElement);
        }
      }
    }
  }
  // 关闭当前之外的视频
  closeVideo(id: string) {
    this.$nextTick(() => {
      this.videoList.forEach((video: HTMLVideoElement) => {
        if (!(video.id === id)) video.pause();
      });
    });
  }
}
